<template>
  <div class="sso-erro-page d-flex flex-column flex-root">
    <div class="login-blob login-blob--top"></div>
    <div class="login-blob login-blob--bottom"></div>
    <div class="login-dots"></div>
    <div class="login-ring"></div>

    <div class="d-flex flex-column-fluid flex-center flex-column">
      <a href="#" class="mb-8">
        <img
          src="/media/comunicante/logo-header-wellon.png"
          alt="Wellon"
          class="sso-erro-logo"
        />
      </a>

      <div class="login-card login-card--erro">
        <div class="login-card-header text-center">
          <div class="mb-5">
            <i
              class="fas fa-exclamation-circle"
              style="font-size: 3.5rem; color: #dc3545"
            ></i>
          </div>
          <h3 class="login-title" style="margin-bottom: 1rem">
            {{ tituloErro }}
          </h3>
          <p
            class="login-subtitle"
            style="line-height: 1.7; color: #6b6b80; font-size: 0.9rem"
          >
            <span v-if="carregando">Carregando...</span>
            <template v-else>{{ mensagem }}</template>
          </p>
        </div>
        <div class="text-center pt-2 pb-3">
          <a
            :href="loginUrl"
            class="btn modern-btn-primary font-weight-bolder px-8"
          >
            Voltar ao login
          </a>
        </div>
        <p class="text-center text-muted" style="font-size: 0.78rem">
          Se necessário, entre em contato com o suporte.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
const MENSAGEM_PADRAO =
  "Ocorreu um erro durante a autenticação. Entre em contato com o suporte.";

export default {
  name: "SSOErro",
  data() {
    return {
      carregando: true,
      mensagem: MENSAGEM_PADRAO
    };
  },
  computed: {
    tituloErro() {
      if (
        this.mensagem.includes("não cadastrado") ||
        this.mensagem.includes("não encontrado")
      ) {
        return "E-mail não localizado";
      }
      return "Erro no Login Integrado";
    },
    loginUrl() {
      return process.env.BASE_URL + "login";
    }
  },
  mounted() {
    // A mensagem nunca trafega em texto livre na URL — o backend manda um
    // token opaco (criptografado com a APP_KEY), e aqui a gente troca esse
    // token pela mensagem real. Isso evita que qualquer um monte uma URL
    // com texto arbitrário nessa tela.
    const token = this.$route.query.t;

    if (!token) {
      this.carregando = false;
      return;
    }

    const api = process.env.VUE_APP_COMUNICANTE_API || window.location.origin;

    fetch(api + "/sso/decodificar-erro?t=" + encodeURIComponent(token))
      .then((r) => r.json())
      .then((resp) => {
        this.mensagem = resp.data?.mensagem || MENSAGEM_PADRAO;
      })
      .catch(() => {
        this.mensagem = MENSAGEM_PADRAO;
      })
      .finally(() => {
        this.carregando = false;
      });
  }
};
</script>

<style scoped>
.sso-erro-page {
  min-height: 100vh;
  width: 100%;
  background: #ffffff;
  position: relative;
  overflow: hidden;
  justify-content: center;
}

.sso-erro-logo {
  height: 34px;
  width: auto;
  display: block;
}

.login-card--erro {
  background: #ffffff;
  border-radius: 20px;
  padding: 2.75rem 2.5rem;
  box-shadow: 0 10px 40px rgba(72, 33, 130, 0.08),
    0 2px 8px rgba(72, 33, 130, 0.06);
  max-width: 440px;
  width: 100%;
  position: relative;
  z-index: 1;
}

.login-title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #482182;
  margin-bottom: 0.5rem;
}

.login-subtitle {
  color: #6b6b80;
  font-size: 0.95rem;
  font-weight: 400;
  margin-bottom: 0;
}

.modern-btn-primary {
  height: 50px;
  background-color: #482182;
  border: none;
  border-radius: 12px;
  color: #ffffff;
  font-size: 1rem;
  box-shadow: 0 4px 14px rgba(72, 33, 130, 0.25);
  transition: transform 0.15s ease, box-shadow 0.15s ease,
    background-color 0.15s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.modern-btn-primary:hover {
  background-color: #3a1a6a;
  box-shadow: 0 6px 18px rgba(72, 33, 130, 0.32);
  transform: translateY(-1px);
}

/* Elementos decorativos */
.login-blob {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  z-index: 0;
}

.login-blob--top {
  top: -90px;
  left: -110px;
  width: 280px;
  height: 280px;
  background: radial-gradient(
    circle,
    rgba(72, 33, 130, 0.16) 0%,
    rgba(72, 33, 130, 0) 70%
  );
}

.login-blob--bottom {
  bottom: -140px;
  left: 18%;
  width: 340px;
  height: 340px;
  background: radial-gradient(
    circle,
    rgba(72, 33, 130, 0.12) 0%,
    rgba(72, 33, 130, 0) 70%
  );
}

.login-dots {
  position: absolute;
  top: 32px;
  left: 32px;
  width: 88px;
  height: 88px;
  background-image: radial-gradient(
    rgba(72, 33, 130, 0.28) 1.5px,
    transparent 1.5px
  );
  background-size: 16px 16px;
  pointer-events: none;
  z-index: 0;
}

.login-ring {
  position: absolute;
  bottom: 48px;
  left: 6%;
  width: 36px;
  height: 36px;
  border: 6px solid rgba(72, 33, 130, 0.14);
  border-radius: 50%;
  pointer-events: none;
  z-index: 0;
}

@media screen and (max-width: 576px) {
  .login-card--erro {
    padding: 2rem 1.5rem;
    box-shadow: none;
  }
  .login-blob,
  .login-dots,
  .login-ring {
    display: none;
  }
}
</style>
